var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteReportWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99865 8.82031L14.1236 4.69531L15.302 5.87365L11.177 9.99865L15.302 14.1236L14.1236 15.302L9.99865 11.177L5.87365 15.302L4.69531 14.1236L8.82031 9.99865L4.69531 5.87365L5.87365 4.69531L9.99865 8.82031Z",
    fill: "var(--text-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteReportWidget);
export default __webpack_public_path__ + "static/media/delete-report-widget.214294ee371f5bb0d9542cd17bb27975.svg";
export { ForwardRef as ReactComponent };